import { zodResolver } from "@hookform/resolvers/zod";
import { Button, Stack } from "@mantine/core";
import { ContextModalProps } from "@mantine/modals";
import { SubmitHandler, useForm } from "react-hook-form";
import z from "zod";

import { Input } from "@/components/_Input";
import { SaveQueueRestoreUpdate, useSaveQueueRestoreUpdateMutation } from "@/store";

type FormData = z.infer<typeof schema>;
const schema = z.object({
  qtyTransported: z.string().refine(
    (value) => {
      const num = parseFloat(value);
      console.log({ num, value });
      return !isNaN(num) && num >= 0;
    },
    { message: "Peso transportado deve ser um número válido e não negativo" }
  )
});

type EditOrderRescueModalProps = ContextModalProps<SaveQueueRestoreUpdate["args"]>;
export function EditOrderRescueModal({ id, context, innerProps }: EditOrderRescueModalProps) {
  const [trigger] = useSaveQueueRestoreUpdateMutation();

  const {
    handleSubmit,
    formState: { isValid, isSubmitting },
    control
  } = useForm({
    mode: "all",
    resolver: zodResolver(schema),
    defaultValues: {
      qtyTransported: innerProps.qtyTransported || "0"
    }
  });
  const onSubmit: SubmitHandler<FormData> = async (data) => {
    const { qtyTransported: _, ...body } = innerProps;
    const { error } = await trigger({ qtyTransported: data.qtyTransported, ...body });
    if (!error) {
      context.closeModal(id);
    }
  };

  return (
    <Stack component="form" onSubmit={handleSubmit(onSubmit)}>
      <Stack>
        <Input.Text control={control} rightSection="t" name="qtyTransported" label="Peso Transportado" maskProps={{ mask: "99.99" }} />
      </Stack>

      <div className="grid! grid-cols-1 gap-2 md:grid-cols-2">
        <Button variant="default" onClick={() => context.closeModal(id)} disabled={isSubmitting}>
          Cancelar
        </Button>
        <Button type="submit" color="yellow" disabled={!isValid} loading={isSubmitting}>
          Salvar
        </Button>
      </div>
    </Stack>
  );
}
